import { render, staticRenderFns } from "./HomeProductBannerPhone.vue?vue&type=template&id=2dcbf26f&scoped=true&"
import script from "./HomeProductBannerPhone.vue?vue&type=script&lang=js&"
export * from "./HomeProductBannerPhone.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductBannerPhone.vue?vue&type=style&index=0&id=2dcbf26f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbf26f",
  null
  
)

export default component.exports